import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp } from '@ifeng-fe/callapp';
import { isGrounds } from '@src/mobile/utils/app';
import { setAppQuery } from '@src/mobile/utils/url';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import styles from './index.css';

const Brand = ({ url = window.location.href, needPlaceHolder = true }) => {
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'web',
            pid: setAppQuery(url),
            kind: 'inter_ayy01',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7262674382196087808',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9170',
        }
    };

    const handleClick = () => {
        callApp({
            docType: 'web',
            pid: setAppQuery(url),
            kind: 'inter_ayy01',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7262674382196087808',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9170',
        });
    };

    return !isGrounds ? (
        <div>
            {needPlaceHolder ? <div className={styles.placeholder} /> : null}
            <div className={styles.wrap}><WxLaunchHack content={wxLaunchHackData} /></div>

        </div>
    ) : null;
};

Brand.propTypes = {
    url: PropTypes.string,
    needPlaceHolder: PropTypes.bool,
};

export default errorBoundary(Brand);
